import { ItemList } from "../../orm"

class AdminS3GalleriesList extends ItemList {

  getEntityKey() {
    return "admin/s3_gallery"
  }
}

class AdminS3CheckSizeList extends ItemList {

  getEntityKey() {
    return "admin/s3_gallery/check_s3_size"
  }

  check({galleryId}) {
    return this.saveNewObject({gallery_id: galleryId})
  }
}

class AdminS3CheckFaceCountList extends ItemList {

  getEntityKey() {
    return "admin/s3_gallery/check_face_count"
  }

  check({galleryId}) {
    return this.saveNewObject({gallery_id: galleryId})
  }
}

export const adminS3GalleriesList = new AdminS3GalleriesList("admin_s3_galleries__default")
export const adminS3CheckSizeList = new AdminS3CheckSizeList("admin_s3_check_size__default")
export const adminS3CheckFaceCountList = new AdminS3CheckFaceCountList("admin_s3_check_face_count__default")
